<template>

  <div
  >
    <v-layout  column>

      <v-flex pl-5 pr-5 class="">
        <v-layout  row wrap >

          <v-flex xs12 >
            <form class="mt-2" name="register" autocomplete="nope">

              <div style="overflow: hidden; height: 0px;background: transparent;" data-description="dummyPanel for Chrome auto-fill issue">
                <input type="text" style="height:0;background: transparent; color: transparent;border: none;" data-description="dummyUsername"></input>
                <input type="password" style="height:0;background: transparent; color: transparent;border: none;" data-description="dummyPassword"></input>
              </div>

              <v-text-field
                v-model="email"
                label="E-mail"
                disabled
                append-icon="check"
                class="notranslate"
              ></v-text-field>

              <v-text-field
                v-validate="'required'"
                v-model="fname"
                @blur="checkIfFilled"
                :error-messages="errors.collect('fname')"
                label="First Name"
                data-vv-name="fname"
              ></v-text-field>

              <v-text-field
                v-validate="'required'"
                @blur="checkIfFilled"
                v-model="lname"
                :error-messages="errors.collect('lname')"
                label="Last Name"
                data-vv-name="lname"
              ></v-text-field>

              <v-text-field
                :append-icon="e1 ? 'visibility' : 'visibility_off'"
                @click:append="() => (e1 = !e1)"
                :type="e1 ? 'password' : 'text'"
                @blur="checkIfFilled"
                hint="At least 8 characters"
                v-validate="'required'"
                v-model="password"
                :error-messages="errors.collect('password')"
                label="Password"
                class="notranslate"
                data-vv-name="password"
              ></v-text-field>

              <v-autocomplete
                v-model="selectedCountry"
                :items="countries"
                item-text="name"
                item-value="id"
                label="Select Country"
                @change="getStates()"
              ></v-autocomplete>

              <v-autocomplete
                v-validate="'required'"
                :error-messages="errors.collect('state')"
                data-vv-name="state"
                v-model="selectedState"
                :items="states"
                item-text="name"
                item-value="id"
                label="Select State"
                @change="checkIfFilled"
              ></v-autocomplete>

              <v-btn block large :loading="loading" :disabled="isFormValidated === false"
                     color="success" class="right" @click="register">submit</v-btn>
            </form>
          </v-flex>
          <v-flex xs12 >
            <em>By selecting <strong>SUBMIT</strong> you accept the <a target="__blank" href="https://www.cogneti.com/terms-of-use"><strong>Cogneti License</strong></a> terms.</em>
          </v-flex>
          <!--          <v-flex xs12  >-->
          <!--            <img src="@/assets/images/back-img-158x150.png" >-->
          <!--          </v-flex>-->
        </v-layout>

      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" persistent :width="$store.getters.getAppWidth - 10">
      <!--<v-btn slot="activator" color="primary" dark>Open Dialog</v-btn>-->
      <v-card>
        <v-card-title class="headline">Success</v-card-title>
        <v-card-text>
          <p>Done. Your own training program has been created for you.</p>
          <p>Sign-in info was sent to:</p>
          <p class="primary--text">{{email}}</p>
          <p>(Check junk or firewall filters)</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" to="/login" @click.native="dialog = false">Sign In</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="creationLoaderDialog"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please wait. Your account is being created...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
import Vue from 'vue'
import crypto from '../../../mixins/crypto'
import common from '../../../mixins/common'
import { mapGetters, mapMutations } from 'vuex'

import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)
function compare (a, b) {
  // Use toUpperCase() to ignore character casing
  const bandA = a.name.toUpperCase()
  const bandB = b.name.toUpperCase()

  let comparison = 0
  if (bandA > bandB) {
    comparison = 1
  } else if (bandA < bandB) {
    comparison = -1
  }
  return comparison
}

function getOS () {
  let userAgent = window.navigator.userAgent
  let platform = window.navigator.platform
  let macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
  let windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
  let iosPlatforms = ['iPhone', 'iPad', 'iPod']
  let os = 'Desktop'
  // Initially following code return Different OS but for now it will return only iOS, Android and Desktop
  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'DESKTOP'
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'IOS'
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'DESKTOP'
  } else if (/Android/.test(userAgent)) {
    os = 'ANDROID'
  } else if (!os && /Linux/.test(platform)) {
    os = 'DESKTOP'
  }
  return os
}

export default {
  name: 'GetNameAndPwd',
  data () {
    return {
      isFormValidated: false,
      creationLoaderDialog: false,
      loading: false,
      dialog: false,
      coupon: '',
      fname: '',
      lname: '',
      uname: '',
      selectedCountry: 233,
      selectedState: '',
      countries: [],
      states: [],
      e1: true,
      password: '',
      dictionary: {
        attributes: {
          email: 'E-mail Address'
        },
        custom: {
          fname: {
            required: () => 'First Name is required'
          },
          lname: {
            required: () => 'Last Name is required'
          },
          password: {
            required: () => 'Password is required'
          }
        }
      }
    }
  },
  created () {
    this.encryptedStr = this.$route.params.email
    this.getCountries()
    this.fname = this.getUserDetails.first_name
    this.lname = this.getUserDetails.last_name
  },
  computed: {
    ...mapGetters('registration', ['getUserDetails']),
    email () {
      return this.decryptData(this.getUserDetails.email)
    },
    isAndroid () {
      const userAgent = navigator.userAgent.toLowerCase()
      return userAgent.includes('android')
    },
    otpId () {
      return this.$route.params.otp_id
    }
  },
  mounted () {
    this.$validator.localize('en', this.dictionary)
    this.coupon = this.$route.query.coupon
  },
  methods: {
    ...mapMutations('registration', [
      'setUser'
    ]),
    goBack () {
      this.goToSignupStep(this.page, 'confirm-my-email')
    },
    getCountries () {
      this.$http({
        url: process.env.API_URL + '/ws/userservice/country',
        method: 'GET'
      }).then((res) => {
        this.countries = res.data.countries
        this.states = res.data.usa.sort(compare)
      })
    },
    getStates () {
      this.$http({
        url: process.env.API_URL + '/ws/userservice/country/' + this.selectedCountry + '/state',
        method: 'GET'
      }).then((res) => {
        // this.countries = res.data.countries
        this.states = res.data.states.sort(compare)
      })
    },
    checkIfFilled () {
      this.$validator.validateAll().then((result) => {
        // console.log('checking for form')
        this.isFormValidated = result
      })
    },
    jsonToQueryString (json) {
      return '' +
        Object.keys(json).map(function (key) {
          return encodeURIComponent(key) + '=' +
            encodeURIComponent(json[key])
        }).join('&')
    },
    me () {
      this.$http({
        url: `${process.env.API_URL}/ws/playerservice/user/${this.email}`,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + this.$auth.token()
        }
      }).then((res) => {
        this.$auth.user(res.data)
        this.$auth.watch.authenticated = true
        document.cookie = 'user_name=' + res.data.friendlyName + ';domain=cogneti.com'
        document.cookie = 'user_email=' + res.data.email + ';domain=cogneti.com'
        localStorage.setItem('user_name', res.data.friendlyName)
        const countryId = res.data.countryId !== null ? res.data.countryId : 233

        this.$store.commit('user/setCountry', countryId)
        this.$store.commit('user/setUserDetails', res.data)
        this.$store.commit('user/setAvatar', res.data.userImageUrl)
        this.$store.commit('user/setFirstName', res.data.firstName)
        this.$store.commit('user/setLastName', res.data.lastName)
        this.$store.commit('user/setUserId', res.data.id)
        this.$store.commit('user/setState', res.data.stateId)
        this.$store.commit('user/setPhone', res.data.phoneNumber)
        this.$store.commit('user/setAddressLine1', res.data.addressLine1)
        this.$store.commit('user/setAddressLine2', res.data.addressLine2)
        this.$store.commit('user/setCity', res.data.city)
        this.$store.commit('user/setPostalCode', res.data.postalCode)
        localStorage.setItem('email', res.data.email)
        this.$store.commit('setDashboardTourStart', 0)
        this.$store.commit('setNewUserLoggedin', true)
        this.$store.commit('setLearnStatus', true)
        this.$store.commit('setQuizStatus', true)
        this.$store.commit('course/setLastPlayedLevel', 0)
        this.$store.commit('course/setLevels', [])
        this.$store.commit('course/setGroups', [])
        this.$store.commit('course/setMemberId', 0)
        // this.$store.commit('course/setExamStatus', -1)
        this.$store.commit('course/setBadgeScore', -1)
        this.$store.commit('course/setCourseLevelLoadedAfterLogin', false)

        if (this.$route.query.coupon) {
          this.$router.push({name: 'QuickPayment', query: {coupon: this.$route.query.coupon}}).catch(() => {
          })
        } else {
          this.$router.push({name: 'QuickPayment'}).catch(() => {})
        }
      })
    },
    login () {
      this.loading = true
      let parameters = {
        grant_type: 'password',
        client_id: process.env.CLIENT_ID,
        client_secret: process.env.CLIENT_SECRET,
        username: this.email,
        password: this.password
      }
      this.loginLoader = true
      this.$auth.login({
        headers: {
        },
        data: this.jsonToQueryString(parameters),
        rememberMe: this.rememberMe,
        success (res) {
          this.$store.commit('setAuthToken', this.$auth.token())
          document.cookie = 'auth_token=' + this.$auth.token() + ';domain=cogneti.com'
          this.me()
        }
      })
    },
    register () {
      // let scope = 'register'
      this.loading = true
      const gameId = +process.env.GAME_ID
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.creationLoaderDialog = true
          this.$store.commit('setLoadingDialog', true, { root: true })
          this.$http({
            url: process.env.API_URL + '/ws/userservice/course/' + gameId + '/register',
            method: 'POST',
            data: {
              'firstName': this.fname,
              'lastName': this.lname,
              'password': this.password,
              'email': this.email,
              'client': this.isAndroid ? 'android' : 'php-client',
              'otpId': this.getUserDetails.email_otp_id,
              'country': this.selectedCountry,
              'state': this.selectedState,
              'app': 'CERTAPP',
              'platform': getOS()
            }
          }).then((res) => {
            this.uname = res.data.friendlyName
            this.creationLoaderDialog = false
            this.$store.commit('setLoadingDialog', false, { root: true })

            this.setUser({
              ...this.getUserDetails,
              welcome: true
            })
            this.login()
          }, error => {
            this.creationLoaderDialog = false
            this.$store.commit('setLoadingDialog', false, { root: true })
            this.$store.commit('flashError', error.message, { root: true })
            this.creationLoaderDialog = false
          }).catch(error => {
            this.creationLoaderDialog = false
            this.$store.commit('setLoadingDialog', false, { root: true })
            this.$store.commit('flashError', error.message, { root: true })
          })
        } else {
          this.creationLoaderDialog = false
        }
      })
    }
  },
  mixins: [crypto, common]
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/user-quick-sign-up/GetNameAndPwd.vue